<template>
  <div class="chart-area">
    <highcharts class="hc" :options="chartOptions" ref="chart"></highcharts>
  </div>
</template>

<script>
export default {
  props:{
    series: {
      type: Array
    }
  },
  watch:{
    series(){
      this.draw();
    }
  },
  computed: {
  },
  data(){
    return {
    idcList: null,
    chartLowData : [
      [100],
      [200],
      [200],
      [200],
      [200],
      [200],
    ],
    chartOptions: {
      chart: {
        type: 'pie',
        inverted: false,
        height: 220
      },

      // colors: ['#14adea', '#151578', '#00d8b5', '#915ffc', '#2d5cff', '#6cf298', '#5b42ea', '#7d9cff'],
      colors: ['#14adea', '#2d5cff', '#7d9cff', '#915ffc', '#5b42ea', '#151578', '#6cf298', '#00d8b5'],

      credits: {
        enabled: false
      },


      accessibility: {
        description : null
      },

      title: {
          text: null
      },

      subtitle: {
          text: null
      },

      xAxis: {
        categories: [],
        labels: {
          style: {
            fontSize: '8.8px'
          }
        },
        //max: 17,

      },

      yAxis: {
        title: {
          text: null
        },
        labels: {
          style: {
            fontSize: '10px'
          }
        },
      },

      tooltip: {
        headerFormat: "<b>{series.name}</b><br/>",
        pointFormat: "{point.name}: {point.y}<br/>",
        // formatter: function() {
        //   console.log(this.series);
        //   console.log(this.point)
        //   return this.series.name+': <b>'+Math.round(this.point.percentage)+'%</b>'
        // },
        borderWidth: 0,
        borderRadius: 0,
        shadow: false
      },

      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false
          },
          showInLegend: true
        }
      },

      legend: {
        align: 'left',
        layout: 'vertical',
        verticalAlign: 'top',
        x: 0,
        y: 0
      },

      series: [{
          name: '방문객 수',
          data: [

          ]
      }]
      },
    }
  },
  mounted(){

    this.loadlocation();
  },
  methods: {
    draw(){
      this.chartOptions.series[0].data = this.series;
    },
    async loadlocation(){
      let location = await this.$store.getters['location/location'];
      this.idcList = location.filter(x => x.isDeleteYN == "N");
      this.loadChart();
    },
    loadChart(){
      var data = []
      this.chartOptions.xAxis.categories = this.idcList.map(x=>x.locationName)
      /*
      this.chartLowData.forEach(function(item){
        item[0]
        var o = {};
        o.low = item[0];
        o.high = item[1];
        o.color = '#117ce9';
        //zone으로 처리 불가하여 이렇게 처리
        if(o.high >= 24)
          o.color = '#ffb819';
        if(o.high >= 26)
          o.color = '#f84d3a';
        data.push(o);
      })
      */
      //this.chartOptions.series[0].data = data
      }
  }
}
</script>

<style>

</style>
